import { Component } from "react";
import { connect } from "react-redux";
import {set_datapage} from '../redux/actions/DataPageAction'

class InicioBackend extends Component {

    constructor (props) {
        super(props)
        
        // this.props.set_datapage('Importar otro')
        console.log('construncto Ejemplo')
        this.props.set_datapage({titulo: 'Intranet',
        subTitulo: 'Area restringida solo personal autorizado',
        isbackend:true,
        breadcrumb:[
            {name:"Intranet",url:"#",active:true}
        ]});
    }
    render() {
        return (
            <section className="section is-main-section">
                <h1>Intranet</h1>
            </section>
        )
    }
}

export default connect(null, {set_datapage})(InicioBackend)